import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: '首页' },
  { path: '/category/sports', label: '体育竞技' },
  { path: '/category/live-casino', label: '真人娱乐' },
  { path: '/category/slots', label: '电子游艺' },
  { path: '/category/promotions', label: '优惠活动' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
          >
            <span
              className="text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <span className="text-primary-500">必赢</span>
              <span className={scrolled ? 'text-foreground-900' : 'text-white'}>亚洲</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500 text-white'
                      : scrolled
                        ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                        : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/category/promotions"
              className="ml-3 px-5 py-2 rounded-full bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
            >
              立即注册
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-800' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-in slide-in-from-top">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/category/promotions"
              className="mt-2 px-4 py-3 rounded-lg bg-accent-500 text-white text-sm font-medium text-center whitespace-nowrap hover:bg-accent-600 transition-colors"
            >
              立即注册
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}